export const getFinancialYearDates = () => {
  const currentDate = new Date();
  let startYear = currentDate.getFullYear();
  let endYear = startYear + 1;

  // If the current date is before April, adjust the financial year to the previous year
  if (currentDate.getMonth() < 3) {
    // March is month 2, so before April
    startYear -= 1;
    endYear -= 1;
  }

  // Financial year starts on April 1st
  const startDate = new Date(startYear, 3, 1); // 3 is April (months are 0-indexed)

  // Financial year ends on March 31st of the next year
  const endDate = new Date(endYear, 2, 31); // 2 is March

  // Function to format date as "Month dd, yyyy"
  const formatDate = (date) => {
    const options = { year: "numeric", month: "long", day: "2-digit" };
    return date.toLocaleDateString("en-US", options);
  };

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate),
  };
};

export const PLAN_DETAILS = {
  "1_day": {
    title: "1 Day Plan",
    description:
      "Gain unlimited reportings access valid until midnight (11:59'PM) today. Perfect for one-off reporting needs, emergencies, or days with unexpected high patient volume. No recurring charges. Ideal for basic plan users who need a quick lift.",
    price: "₹20.00",
    color: "#4CAF50",
  },
  "1_week": {
    title: "1 Week Plan",
    description:
      "Enjoy 7 days of unrestricted reportings — whether you're running screening camps, experiencing a busy patient inflow, or just need uninterrupted operations. Affordable and flexible for short-term scaling.",
    price: "₹135.00",
    color: "#FF9800",
  },
  "1_month": {
    title: "1 Month Plan",
    description:
      "Unlock full access to unlimited reportings for 30 consecutive days. Designed for high-volume users, growing labs, or institutions needing uninterrupted access without the limitations of a basic plan. Best value and peace of mind guaranteed.",
    price: "₹550.00",
    color: "#ef233c",
  },
};
